// Converter info comes in different asynchronous pieces. will we really need a status on each piece?
// like preview fail/success, size fail/success, unit fail/success?
// those values should not be changed, but new keys can be applied
export enum ConversionStatus {
  PENDING = 1,
  CONVERTING = 2,
  SUCCESS = 3,
  FAILED = 4,
  SAMPLE = 5,
}

export enum AssetType {
  // At least the first for of these values correspond to the classes of entity that reference asset,
  // i.e. there is an ImageAsset, a CadAsset and GenericFile is arguably a GenericFileAsset
  // Hence I've added AUTO_ESTIMATION as it seems to be consistent
  IMAGE = "IMAGE",
  CAD = "CAD",
  GENERIC_FILE = "GENERIC_FILE",
  AUTO_ESTIMATION = "AUTO_ESTIMATION",
  AUTO_ESTIMATION_SNAPSHOT = "AUTO_ESTIMATION_SNAPSHOT",
  PART_ESTIMATION_SNAPSHOT = "PART_ESTIMATION_SNAPSHOT",
  ORIENTATION_AUTO = "ORIENTATION_AUTO",
  ORIENTATION_DEFAULT = "ORIENTATION_DEFAULT",
  ORIENTATION_FRONT = "ORIENTATION_FRONT",
  ORIENTATION_BACK = "ORIENTATION_BACK",
  ORIENTATION_LEFT = "ORIENTATION_LEFT",
  ORIENTATION_RIGHT = "ORIENTATION_RIGHT",
  ORIENTATION_TOP = "ORIENTATION_TOP",

  IMAGE_SAMPLE = "IMAGE_SAMPLE",
  CAD_SAMPLE = "CAD_SAMPLE",
  GENERIC_SAMPLE = "GENERIC_SAMPLE",
}

export type SampleAssetTypes =
  | AssetType.CAD_SAMPLE
  | AssetType.GENERIC_SAMPLE
  | AssetType.IMAGE_SAMPLE;

export const sampleAssetTypes: SampleAssetTypes[] = [
  AssetType.CAD_SAMPLE,
  AssetType.GENERIC_SAMPLE,
  AssetType.IMAGE_SAMPLE,
];
